import {
  Alert,
  AlertTitle,
  Box,
  Card,
  CardContent,
  CardHeader,
  Tooltip,
  Typography,
} from '@mui/material';
import { useFeedDetailsCtx } from '../FeedDetails.context';
import useFeedOptions from '../api/useFeedOptions';
import { SimpleTable, TableSkeleton } from '@brandbank/portal-components';

const FeedsOverviewPurposeOptions = () => {
  const { detail } = useFeedDetailsCtx();
  const purposeId = String(detail.id || '');

  const { data = [], error, status } = useFeedOptions(purposeId);

  const renderValue = (
    value: string,
    maxWidth: string,
    shouldTruncate = true
  ) => {
    return shouldTruncate ? (
      <Tooltip title={value}>
        <Typography
          sx={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            maxWidth,
          }}
        >
          {value}
        </Typography>
      </Tooltip>
    ) : (
      <Typography
        sx={{
          whiteSpace: 'nowrap',
          maxWidth,
        }}
      >
        {value}
      </Typography>
    );
  };

  return (
    <Card>
      <CardHeader
        title='Purpose Options'
        titleTypographyProps={{
          variant: 'h6',
        }}
      />

      <CardContent>
        {status === 'loading' && <TableSkeleton numColumns={2} numRows={1} />}

        {status === 'error' && (
          <Alert severity='error'>
            <AlertTitle>
              <strong>Unable to load options</strong>
            </AlertTitle>
            {error
              ? error.message
              : 'An error occurred whilst getting activities'}
          </Alert>
        )}
        {status === 'success' && (
          <>
            {data.length === 0 ? (
              <Typography>No options found</Typography>
            ) : (
              <Box data-testid='feeds-options-log-table'>
                <SimpleTable
                  columns={[
                    {
                      id: 'name',
                      label: 'Option',
                      render: (row) => renderValue(row.name, '300px'),
                    },
                    {
                      id: 'value',
                      label: 'Value',
                      render: (row) => renderValue(row.value, '100px'),
                    },
                  ]}
                  items={data}
                  sx={{ borderRadius: 1, maxHeight: 250 }}
                  tableProps={{
                    size: 'small',
                    stickyHeader: true,
                  }}
                />
              </Box>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default FeedsOverviewPurposeOptions;
